import React, { Component } from 'react';
import { Icon, Button } from 'antd';
import _ from 'lodash';
import { Image, Maps, Search, JoinUsForm, ContactForm, SocialList } from '../components';
import { withRedux } from '../hoc';
import { getServiceUrl } from '../utils';
import { getPagecontactAction } from '../actions/page/contact';

const mapStateToProps = state => {
  return {
    t: _.get(state, 't'),
    languages: _.get(state, 'languages'),
    page: _.get(state, 'page')
  };
};

const actions = {
  getPagecontactAction
};

@withRedux(mapStateToProps, actions)
export default class Contact extends Component {
  componentDidMount() {
    this.init(this.props);
    this.props.actions.getPagecontactAction();
  }
  componentWillReceiveProps(nextProps) {
    if (!_.isEqual(this.props.location, nextProps.location)) {
      this.init(nextProps);
    }
  }
  init = props => {
    const hash = _.get(props, 'location.hash');
    if (!_.isEmpty(hash)) {
      document.querySelector(hash).scrollIntoView();
    }
  };
  render() {
    const { t } = this.props;
    const data = _.get(this.props, 'page.contact.data');
    const media_image_full_file_path = `${getServiceUrl()}/${t(_.get(data, 'media_image_data.path'))}`;
    return (
      <div className="contact-page container-wrapper">
        <div className="search-block">
          <Search.Main />
        </div>
        <div
          className="topic"
          id="contact"
          dangerouslySetInnerHTML={{
            __html: t({
              en: '- Contact <span class="text-red">Us</span> -',
              th: '- ติดต่อเรา -'
            })
          }}
        />
        <div className="top-content">
          <div className="section-1">
            <div className="container">
              <div className="row">
                <div className="col-md-7">
                  <div className="image">
                    <Image src={media_image_full_file_path} />
                  </div>
                </div>
                <div className="col-md-5">
                  <div className="address-block">
                    <div className="company-name">{t(_.get(data, 'company_name'))}</div>
                    {_.map(_.get(data, 'address'), (value, index) => {
                      return (
                        <div key={index} className="address-branch">
                          <div className="title">{t(_.get(value, 'branch'))}</div>
                          <div className="detail">
                            <div className="address">{t(_.get(value, 'address'))}</div>
                            <table>
                              <tbody>
                                <tr>
                                  <td>{t('Tel')}.</td>
                                  <td>{t(_.get(value, 'telephone'))}</td>
                                </tr>
                                <tr>
                                  <td>{t('Fax')}</td>
                                  <td>{t(_.get(value, 'fax'))}</td>
                                </tr>
                                <tr>
                                  <td>{t('E-mail')}</td>
                                  <td>{t(_.get(value, 'email'))}</td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="section-2" id="maps">
            <div className="container">
              <div className="row">
                <div className="col-md-7">
                  <div className="left">
                    <div className="title">{t('Maps')}.</div>
                    {_.map(_.get(data, 'address'), (value, index) => {
                      const branch = t(_.get(value, 'branch'));
                      const latitude = _.get(value, 'latitude');
                      const longitude = _.get(value, 'longitude');
                      const mapsData = t(_.get(value, 'media_maps_data'));
                      // const downloadMaps = _.get(mapsData, "full_file_path");
                      const downloadMaps = `${getServiceUrl()}/${_.get(mapsData, 'path')}`;
                      return (
                        <div key={index} className="google-maps">
                          <div className="maps">
                            <Maps
                              googleMapURL={`https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_MAPS_KEY}&v=3.exp&libraries=geometry,drawing,places`}
                              loadingElement={<div style={{ height: '100%' }} />}
                              containerElement={<div style={{ height: '100%' }} />}
                              mapElement={<div style={{ height: '100%' }} />}
                              center={{
                                lat: latitude,
                                lng: longitude
                              }}
                              marker={{
                                lat: latitude,
                                lng: longitude
                              }}
                            />
                          </div>
                          <div className="company-branch">{branch}</div>
                          <div className="get-direction">
                            <Button
                              href={`https://www.google.com/maps/dir//${latitude},${longitude}`}
                              target="_blank"
                              type="danger"
                            >
                              {t('Get Direction')}
                            </Button>
                          </div>
                          <a href={downloadMaps} target="_blank" download>
                            <div className="download-maps">
                              <Icon type="download" />
                              <div className="text">{t('Download maps')}</div>
                            </div>
                          </a>
                        </div>
                      );
                    })}
                    <div className="social-block">
                      <div className="text">{t('Follow Us')}</div>
                      <SocialList />
                    </div>
                  </div>
                </div>
                <div className="col-md-5">
                  <div className="right">
                    <div className="title">{t('Also You can contact us by filling the form.')}</div>
                    <div className="form-block">
                      <ContactForm />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="bottom-content" id="careers">
          <div className="section-3">
            <div className="container">
              <div className="row">
                <div className="col-md-7">
                  <div className="left">
                    <div className="title">{t('Working at KKC')}</div>
                    <div className="detail">{t(_.get(data, 'career_text'))}</div>
                  </div>
                </div>
                <div className="col-md-5">
                  <div className="right">
                    <div
                      className="title"
                      dangerouslySetInnerHTML={{
                        __html: t({
                          en: "If you'd like to apply for a position,<br />fill in the form:",
                          th: 'หากคุณต้องการสมัครงาน กรุณากรอกแบบฟอร์ม:'
                        })
                      }}
                    />
                    <div className="form-block">
                      <JoinUsForm />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Contact.js